import { render, staticRenderFns } from "./ServiceInquiryDetail.vue?vue&type=template&id=69ad1d54&scoped=true"
import script from "./ServiceInquiryDetail.vue?vue&type=script&lang=js"
export * from "./ServiceInquiryDetail.vue?vue&type=script&lang=js"
import style0 from "./ServiceInquiryDetail.vue?vue&type=style&index=0&id=69ad1d54&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69ad1d54",
  null
  
)

export default component.exports